import React, { Component } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize.min.js'
import $ from 'jquery';
import { Link } from 'react-router-dom';
import noUiSlider from 'nouislider';
import {updateSettings} from '../../actions/ui/settings';
import {settings} from '../../config.js'
import Modal from '../helper/modal';

class Settings extends Component {
  state = this.props.settings
  componentDidMount(){
    setTimeout(()=>{
      // let hello = $('#modalSettings');
      // $('#modalSettings').remove();
      // $('html').append(hello);
    },2000);

    var slider = document.getElementById('order-slider');

    let _this = this;

    noUiSlider.create(slider, {
        start: [_this.state.minOrder],
        connect: [true, false],
        range: {
            'min': [10,10],
            '20%': [20, 5],
            '25%': [25, 25],
            '50%': [50,50],
            'max': [100]
        }
    });
    slider.noUiSlider.on('update', function (values, handle) {
        _this.setState({
          minOrder:Math.round(values[0])
        });
    });
  }
  saveModal(){
    let settings = this.state;
    this.props.networksettings.forEach(({id})=>{
      settings[id] = $(`#${id}`)[0].value;
    });
    window.localStorage.setItem('settings',JSON.stringify(settings));
    this.props.updateSettings(settings,()=>{});
  }
  renderModal(){
    let component = (<div className='row'> {this.trading()} </div>);
    return (
      <Modal id='modalSettings' classes='modal modalOrders black-text' title='Settings' buttonText={"Save"} buttonAction={this.saveModal.bind(this)} component={component} logout={true} />
    )
  }
  network(){
    let settings = this.props.networksettings

    let items = settings.map(({title,id,max,min}, i)=>{
      return (
        <div className='row' key={i} style={{marginBottom:'5px'}}>
          <div style={{}} className='col s6'>
            <h6 style={{fontSize:'1rem',float:'right',lineHeight:'38.5px'}} className='black-text'> <b>{title} </b> </h6>
          </div>
          <div className='col s3'>
            <input id={id} type={max ? 'number' : 'text'} min={min} max={max} className='black-text' style={{marginTop:'12px'}}/>
          </div>
        </div>
      )
    });
    return (
      <div id="network">
        {items}
      </div>
    )
  }
  clickBox(event){
    this.setState({autoTrader:!this.state.autoTrader})
  }
  activateTrader(){
    return (
      <div className='row' style={{marginBottom:'5px'}}>
        <div style={{}} className='col s6 '>
          <h6 style={{fontSize:'1rem',float:'right',lineHeight:'38.5px'}} className='black-text'><b>Activate Auto-Trader</b></h6>
        </div>
        <div style={{}} className='col s3'>
          <form>
              <p style={{marginTop:'19px'}}>
                <label>
                  <input type='checkbox' onChange={this.clickBox.bind(this)} defaultChecked={this.state.autoTrader ? 'checked' : ''}/>
                  <span style={{display:'block'}}></span>
                </label>
              </p>
          </form>
        </div>
      </div>
    )
  }
  trading(){
    let settings = [
      {title:"Min Order Fulfillment: ", status:`${this.state.minOrder}%`,id:'order-slider',width:"100%"},
    ];

    let items = settings.map(({title,status,id,width}, i)=>{
      return (
        <div key={i} className='row' style={{marginBottom:'5px'}}>
          <div style={{}} className='col s6 '>
            <h6 style={{fontSize:'1rem',float:'right',lineHeight:'38.5px'}} className='black-text'> <b>{title} </b> {status}</h6>
          </div>
          <div className='col s6'>
            <div style={{padding:'22px',width}}> <div id={id}></div></div>
          </div>
        </div>
      )
    });

    return (
      <div className='row' id="trading">
        {this.activateTrader()}
        {items}
        {this.network()}
      </div>
    )
  }
  openModal(){
    let _this = this;
    var instance = M.Modal.getInstance(document.querySelectorAll('#modalSettings')[0]);
    instance.open();
    setTimeout(()=>{
      _this.props.networksettings.forEach(({id})=>{
        $(`#${id}`)[0].value = _this.state[id];
      });
    },100);
  }
  render(){
    return (
      <li>
        <Link to="#">
          <i className="material-icons icon" onClick={this.openModal.bind(this)}>settings</i>
        </Link>
        {this.renderModal()}
      </li>
    )
  }
}


function mapStateToProps(state,props) {
  let networksettings = [
    {title:"Order Lifespan (# of BC BLocks):",id:'deposit',width:'100%',max:1000,min:10},
    {title:"Settlement Length (# of BC BLocks):",id:'settlement',width:'100%',max:1000,min:10},
    {title:"BC Miner Hostname: ",id:'hostname',width:"100%"},
    {title:"BC Miner Port: ",id:'port',width:"100%"},
  ];

  return {
    settings: state.settings.settings,
    networksettings
  };
}


export default connect(mapStateToProps, {updateSettings,
  // collateralizeFilter
})(Settings);
